import { create } from "zustand";
import { OrganizationLocationDto } from "../../../models/location/dto/location.dto";
import { createSelectors } from "../../../utils/store";

type State = {
    selectedLocation?: OrganizationLocationDto;
    setSelectedLocation: (newLocation: OrganizationLocationDto | null) => void;
}
const store = create<State>((set, get) => {
    return {
        selectedLocation: undefined,
        setSelectedLocation: (selectedLocation: OrganizationLocationDto | null) => set({ selectedLocation })
    }
})
export const useSelectedLocation = createSelectors(store);
